type UtilityRefreshListener = () => void;

let listeners: UtilityRefreshListener[] = [];

export const triggerUtilityRefresh = () => {
  listeners.forEach((listener) => listener());
};

export const subscribeUtilityRefresh = (listener: UtilityRefreshListener) => {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
};